var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPctLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    width: 120,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 2.5px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-4, .cls-5 {\r\n        stroke: #f36c21;\r\n      }\r\n\r\n      .cls-6 {\r\n        letter-spacing: -.06em;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cls-7 {\r\n        letter-spacing: -.09em;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #f60;\r\n        font-family: UniversForFiserv55, 'Univers for Fiserv';\r\n        font-size: 34.17px;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-9 {\r\n        letter-spacing: -.06em;\r\n      }\r\n\r\n      .cls-10 {\r\n        letter-spacing: -.15em;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "credit-card-payment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1346",
    "data-name": "Shape 1346",
    className: "cls-1",
    d: "M89.68,30.69c-2.84,0-5.14,2.77-5.14,6.19v99.11c0,6.84,4.6,12.39,10.28,12.39h46.25c5.68,0,10.28-5.55,10.28-12.39V36.88c0-3.42-2.3-6.19-5.14-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1347",
    "data-name": "Shape 1347",
    className: "cls-1",
    d: "M90.37,30.52h55.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1348",
    "data-name": "Shape 1348",
    className: "cls-1",
    d: "M84.54,91.63h66.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1349",
    "data-name": "Shape 1349",
    className: "cls-1",
    d: "M94.84,124.06h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1350",
    "data-name": "Shape 1350",
    className: "cls-1",
    d: "M110.26,124.06h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1351",
    "data-name": "Shape 1351",
    className: "cls-1",
    d: "M125.67,124.06h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1352",
    "data-name": "Shape 1352",
    className: "cls-1",
    d: "M94.84,134.34h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1353",
    "data-name": "Shape 1353",
    className: "cls-1",
    d: "M110.26,134.34h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1354",
    "data-name": "Shape 1354",
    className: "cls-1",
    d: "M125.67,134.34h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1355",
    "data-name": "Shape 1355",
    className: "cls-1",
    d: "M94.84,113.78h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1356",
    "data-name": "Shape 1356",
    className: "cls-1",
    d: "M110.26,113.78h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1357",
    "data-name": "Shape 1357",
    className: "cls-1",
    d: "M125.67,113.78h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1358",
    "data-name": "Shape 1358",
    className: "cls-1",
    d: "M94.84,103.51h10.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1359",
    "data-name": "Shape 1359",
    className: "cls-1",
    d: "M115.39,103.51h5.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1360",
    "data-name": "Shape 1360",
    className: "cls-1",
    d: "M130.81,103.51h10.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1361",
    "data-name": "Shape 1361",
    className: "cls-1",
    d: "M141.09,134.34v-20.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1363",
    "data-name": "Shape 1363",
    className: "cls-1",
    d: "M110.26,40.7h15.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_27",
    "data-name": "Rectangle-path 27",
    className: "cls-2",
    d: "M104.2,51.83h6.11v6.11h-6.11v-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_28",
    "data-name": "Rectangle-path 28",
    className: "cls-2",
    d: "M104.2,73.21h6.11v6.11h-6.11v-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_29",
    "data-name": "Rectangle-path 29",
    className: "cls-2",
    d: "M125.59,51.83h6.11v6.11h-6.11v-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_480",
    "data-name": "Shape 480",
    className: "cls-2",
    d: "M104.2,67.1h12.22v3.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_481",
    "data-name": "Shape 481",
    className: "cls-2",
    d: "M122.53,70.16v9.16h9.16v-9.16h-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_482",
    "data-name": "Shape 482",
    className: "cls-2",
    d: "M116.42,76.27v3.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_483",
    "data-name": "Shape 483",
    className: "cls-2",
    d: "M116.42,51.83v9.16h3.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_480-2",
    "data-name": "Shape 480",
    className: "cls-2",
    d: "M122.29,65.84h9.13"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape_484",
    "data-name": "Shape 484",
    className: "cls-3",
    d: "M181.73,148.59h11.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-scroll"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_608",
    "data-name": "Shape 608",
    className: "cls-4",
    d: "M200.41,78.26h8.01c2.4,0,4.74.74,6.7,2.12l26.22,18.35h11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_612",
    "data-name": "Shape 612",
    className: "cls-5",
    d: "M200.41,159.96v20.64c0,6.46-5.24,11.7-11.7,11.7h-58.48c-6.46,0-11.7-5.24-11.7-11.7v-111.11c0-6.46,5.24-11.7,11.7-11.7h58.48c6.46,0,11.7,5.24,11.7,11.7v40.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_611",
    "data-name": "Shape 611",
    className: "cls-4",
    d: "M159.47,179.13c.81,0,1.46.65,1.46,1.46h0c0,.81-.65,1.46-1.46,1.46h0c-.81,0-1.46-.65-1.46-1.46h0c0-.81.65-1.46,1.46-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_610",
    "data-name": "Shape 610",
    className: "cls-4",
    d: "M200.41,168.9h-81.87"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_27-2",
    "data-name": "Rectangle-path 27",
    className: "cls-4",
    d: "M132.7,88.76h11.7v11.7h-11.7v-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_28-2",
    "data-name": "Rectangle-path 28",
    className: "cls-4",
    d: "M132.7,129.69h11.7v11.7h-11.7v-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_29-2",
    "data-name": "Rectangle-path 29",
    className: "cls-4",
    d: "M173.64,88.76h11.71v11.7h-11.71v-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_480-3",
    "data-name": "Shape 480",
    className: "cls-4",
    d: "M132.7,117.99h23.39v5.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_481-2",
    "data-name": "Shape 481",
    className: "cls-4",
    d: "M167.79,123.84v17.54h17.54v-17.54h-5.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_482-2",
    "data-name": "Shape 482",
    className: "cls-4",
    d: "M156.09,135.54v5.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_483-2",
    "data-name": "Shape 483",
    className: "cls-4",
    d: "M156.09,88.76v17.54h5.85"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_609",
    "data-name": "Shape 609",
    className: "cls-5",
    d: "M253.04,157.2h-29.24c-12.55-.85-22.54-10.84-23.39-23.39h-17.54c-6.46,0-11.7-5.24-11.7-11.7s5.24-11.7,11.7-11.7h32.16"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(75.18 231.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 17.8,
    y: 0
  }, "agos con"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: -21.39,
    y: 41.01
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: -5.81,
    y: 41.01
  }, "ransferencia"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPctLogo);
export default __webpack_public_path__ + "static/media/PCT-logo.1c55d8ff4c9ecc2fd12b44d542fa7ef0.svg";
export { ForwardRef as ReactComponent };